module.exports = __webpack_public_path__ + "static/img/head-ar.933fd364.png";